import React from 'react';
import PropTypes from 'prop-types';
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import FormModal from "../../../components/common/modals/FormModal";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import {allContactPointSystemCodesDropdown, allContactPointUseCodesDropdown} from "../../../relay/Fragments";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";
import {createOptions} from "../../../helpers/utils";

const NewFacilityContactPointModal = ({showModal, onClose, facilityId, systemCodes, useCodes}) => {
    const mutation = graphql`
    mutation NewFacilityContactPointModalMutation($facilityId:ID!, $contactPointSystemId: ID!,$contactPointUseId: ID!,
        $value: String!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
        facility {
            createContactPoint(input: {facilityId: $facilityId, contactPointSystemId: $contactPointSystemId,
                contactPointUseId: $contactPointUseId, value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                facilityContactPoint {
                    id
                    facility {
                        contactPoints {
                            ...FacilityContactPoints_ContactPoints
                        }}}}}}`
    const contactPointSystem = createOptions(useFragment(allContactPointSystemCodesDropdown, systemCodes), 'id', 'display');
    const contactPointUse = createOptions(useFragment(allContactPointUseCodesDropdown, useCodes), 'id', 'display');
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        facilityId: facilityId,
        contactPointSystemId: '',
        contactPointUseId: '',
        value: '',
    };
    const schema = bandedSchema.shape({
        contactPointSystemId: yup.string().required("System Code is required"),
        contactPointUseId: yup.string().required("Use Code is required"),
        value: yup.string().required("Value is required")
    });
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.facility) {
                    toast.success("Contact Point for Facility created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Contact Point"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormSelect options={contactPointSystem} controlId={"contactPointSystemId"} label={"System Code"} />
            <HorizontalFormSelect options={contactPointUse} controlId={"contactPointUseId"} label={"Use Code"} />
            <HorizontalFormInput controlId={"value"} label={"Value"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
NewFacilityContactPointModal.propTypes = {}
export default NewFacilityContactPointModal